import React, { useContext } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { GetUserContext } from "../../Context/GetUserContext";
import { SetUserContext } from "../../Context/SetUserContext";
import registerUserAndCompany from "../../controller/api/RegisterUserAndCompany";

export const RegisterRight = () => {
  const { size, setRegisterYourSelf } = useContext(GetUserContext);
  const registerUserCompany = new registerUserAndCompany();
  const {
    city,
    state,
    ibge,
    cep,
    neighborhood,
    region,
    street,
    numberAddress,
    uf,
    complement,
    logo,
    corporateName,
    landline,
    cnpj,
    emailCompany,
    webSite,
    // User
    name,
    setName,
    cpf,
    setCpf,
    email,
    setEmail,
    password,
    setPassword,
    telephone,
    setTelephone,
  } = useContext(SetUserContext);

  const handleRegisterUserAndCompany = (e) => {
    e.preventDefault();
    const datas = {
      // datas Address
      city,
      state,
      ibge,
      cep,
      neighborhood,
      region,
      street,
      numberAddress,
      complement,
      // datas Company
      logo,
      corporateName,
      landline,
      cnpj,
      emailCompany,
      webSite,
      // datas User
      name,
      cpf,
      email,
      password,
      telephone,
    };

    registerUserCompany
      .addUserAndCompany(datas)
      .then((response) => {
        if (response.status == 200) {
          //window.location.reload()
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(street)

  return (
    <Form onSubmit={handleRegisterUserAndCompany} className="form-horizontal">
      <div className="d-flex justify-content-between">
        <div></div>
        <p>
          <span className="text-danger">* </span>Campo Obrigatório
        </p>
      </div>
      <div className="d-flex justify-content-between">
        <div className="w-100">
          <div>
            Nome<span className="text-danger">*</span>
          </div>
          <div>
            <input
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="form-control"
              type="text"
            />
          </div>
        </div>
      </div>
      <hr></hr>
      <div className="d-flex justify-content-between">
        <div className="w-100">
          <div>
            CPF<span className="text-danger">*</span>
          </div>
          <div>
            <input
              name="cpf"
              value={cpf}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                if (value.length <= 11) setCpf(value);
              }}
              className="form-control"
              type="text"
              placeholder="Apenas números"
            />
          </div>
        </div>
      </div>
      <hr></hr>

      <div
        className={`${
          size?.categoria === "small"
            ? "d-block  "
            : "d-flex justify-content-between"
        }`}
      >
        <div className="w-100">
          <div>
            Senha<span className="text-danger">*</span>
          </div>
          <div>
            <input
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className="form-control"
              type="password"
            />
          </div>
        </div>

        <div style={{ margin: "8px" }}></div>

        <div className="w-100">
          <div>
            Confirme sua senha<span className="text-danger">*</span>
          </div>
          <InputGroup>
            <input
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className="form-control"
              type="password"
            />
          </InputGroup>
        </div>
      </div>
      <hr></hr>
      <div
        style={{ margin: "0 auto" }}
        className="w-100 d-flex justify-content-center align-items-center"
      >
        <button className="btn btn-warning w-75 btn-lg">Cadastrar</button>
      </div>
      <hr></hr>
      <div className="w-100 d-flex justify-content-center align-items-center">
        <div
          onClick={() => {
            setRegisterYourSelf(false);
          }}
          style={{ cursor: "pointer", textDecoration: "underline" }}
        >
          Voltar para tela de Login
        </div>
      </div>
    </Form>
  );
};
